<script setup>
// Restaurant admin messaging under the /admin/messaging route.
// Re-uses the existing ra-messages page component.
import RaMessagesPage from '@/pages/ra-messages.vue'
</script>

<template>
  <RaMessagesPage />
</template>

<route lang="yaml">
meta:
  layout: website
  action: read
  subject: Auth
  allowLoggedInOnly: true
  requiresRestaurantAdmin: true
</route>
